export { default } from './MediaGallery';